import React, { Component } from 'react'
import Hammer from 'react-hammerjs'

import HomeSlider from './HomeSlider'
import Scrolldown from '../Global/Scrolldown'
import SliderArrow from '../Global/SliderArrow'

import scrollIt from '../../utils/scrollIt'

class Home extends Component {
  constructor(props) {
    super(props)

    this.state = {
      navSlider: undefined,
      slug: '',
    }

    this.handleSwipe = this.handleSwipe.bind(this)
    this.goToTrip = this.goToTrip.bind(this)
  }
  componentDidMount() {
    // Add Slider states
    this.setState({
      navSlider: this.navSlider
    })

    if (document.querySelector('.home__wrapper')) {
      this.setWindowHeight(document.querySelector('.home__wrapper'))
      this.setWindowHeight(document.querySelector('.home__holder'))

      scrollIt(document.querySelector('.home__wrapper'))
    }
  }
  /**
   * Set Window Height to an element (fix for iOS browser)
   * @param {HTMLElement} element Element that get the window height as min height
   * @param {Number} offset Get difference between window height and an offset
   */
  setWindowHeight(element, offset = 0) {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && element) {
      element.style.minHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - offset + 'px'

      window.onresize = () => {
        if (element) {
          element.style.minHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) - offset + 'px'
        }
      }
    }
  }
  /**
   * Destroy setWindowHeight method
   * @param {HTMLElement} element Element that get the default min-height
   */
  destroyWindowHeight(element) {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && element) {
      element.style.minHeight = '0'
    }
  }
  /**
   * Get current swipe datas
   * @param {Object} e Swipe Event
   */
  handleSwipe(e) {
    if (Math.sign(e.deltaY) === -1) {
      this.goToTrip()
    }
  }
  /**
   * Animation to Single Trip view
   */
  goToTrip() {
    const { history } = this.props
    const { slug } = this.state

    history.push({
      pathname: `/${slug}`,
      state: {
        to: 'trip',
      },
    })
  }
  render() {
    const { handleInitialSlide, initialSlide, mainSlider, trips } = this.props
    const { slug } = this.state
    const navSliderSettings = {
      dots: true,
      infinite: true,
      prevArrow: <SliderArrow to="prev" />,
      nextArrow: <SliderArrow to="next" />,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: mainSlider,
      initialSlide,
      ref: slider => (this.navSlider = slider),
      onInit: () => {
        const slug = this.props.trips[initialSlide].slug

        this.setState({ slug })
      },
      afterChange: index => {
        const updateInitialSlide = index => handleInitialSlide(index)
        const slug =
          document.getElementById('home-slider')
            .querySelector(`[data-index="${index}"]`)
            .querySelector('.carousel__slide')
            .dataset
            .slug

          this.setState({ slug })

        updateInitialSlide(index)
      }
    }

    return (
      <div className="home__wrapper">
        <Hammer onSwipe={this.handleSwipe} direction="DIRECTION_VERTICAL">
          <div className="home__holder">
            <div className="container">
              <HomeSlider sliderSettings={navSliderSettings} trips={trips} />
              <Scrolldown handleClick={this.goToTrip} slug={slug} />
            </div>
          </div>
        </Hammer>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.js